import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function StopSolidIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M4 8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
    })
  });
}
;
StopSolidIcon.displayName = "StopSolidIcon";
export default forwardRef(StopSolidIcon);